import getJson from '../../assets/data/dashboardSpec';
import { getCsvUrl } from './getCsvUrl.api';

export async function addSource(dashboardApi, url, reportId) {
	console.log('THis is thee afaf');

	getJson(url, reportId).then((data) => {
		console.log('sampleModule', data);

		dashboardApi.addSources([
			{
				module: data,
				name: reportId,
				id: reportId,
			},
		]);
	});
}
